import { render, staticRenderFns } from "./ProposalApplication.vue?vue&type=template&id=1982295e"
import script from "./ProposalApplication.vue?vue&type=script&lang=js"
export * from "./ProposalApplication.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports